/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSsmAutomationExecution extends models.AwsSsmBaseExecution {
    constructor() {
        super();
        this.setDiscriminator("AwsSsmAutomationExecution");
    }

    getFixupPrototypeFunction() { return AwsSsmAutomationExecution.fixupPrototype; }

    static newInstance(model: Partial<AwsSsmAutomationExecution>): AwsSsmAutomationExecution {
        let obj = Object.assign(new AwsSsmAutomationExecution(), model);
        AwsSsmAutomationExecution.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSsmAutomationExecution>): AwsSsmAutomationExecution {
        if (!model) return null;
        return AwsSsmAutomationExecution.newInstance(<AwsSsmAutomationExecution> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSsmAutomationExecution) {
        if (!obj) return;

        models.AwsSsmAutomationExecution.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSsmAutomationExecution): boolean {
        if (models.AwsSsmBaseExecution.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AwsSsmAutomationExecution.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.resolved_targets) {
            models.AwsSsmResolvedTarget.fixupPrototype(this.resolved_targets);
        }
    }

    /**
     * Flag to check if the executed step is truncated.
     */
    step_execution_truncated: boolean;

    /**
     * Mode of the Base Execution
     */
    mode: models.AwsSsmBaseExecutionMode;

    /**
     * IAM ARN of the user who executed the document
     */
    executed_by: string;

    /**
     * Type of the automation document
     */
    automation_type: string;

    /**
     * Output fields of the step
     */
    outputs: { [key: string]: string; };

    /**
     * resolved target resources
     */
    resolved_targets: models.AwsSsmResolvedTarget;

    /**
     * Failure message of the job.
     */
    failure_message: string;

}
